import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  icon = 'ri-fire-line',
  moreTo,
  moreLabel = '查看全部',
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3">
        <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-600">
          <i className={`${icon} text-xl`}></i>
        </span>
        <div>
          <h2 className="font-heading text-lg md:text-2xl font-bold text-foreground-950">{title}</h2>
          {subtitle && <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}